// extracted by mini-css-extract-plugin
module.exports = {"copy-right":"SeoCopyRight_copy-right__Xg2PF"};